import { isEmpty } from "~/Services/Helpers/isEmpty";

const Seconds = (n) => n * 1000;

const baseURL = !isEmpty(process.env.PUBLIC_URL)
    ? process.env.PUBLIC_URL
    : `https://apis.srv701689.hstgr.cloud/api`;
// : "http://192.168.1.103:8000/api"
// : "http://192.168.1.107:8000/api"

export const getURL = (path) =>
    !isEmpty(process.env.REACT_APP_BACKEND_BASE_URL)
        ? `${process.env.REACT_APP_BACKEND_BASE_URL}/${path}/`
        : `https://apis.srv701689.hstgr.cloud/api`;
// : "http://192.168.1.103:8000/api"
// : "http://192.168.1.107:8000/api"

export default {
    baseURL,
    apiUrl: getURL("api"),
    timeout: Seconds(200),
    clientToken: "SECRET_TOKEN",
    version: "1.0.0",
    email: "cuerox@cuerox.com",
    phone: "+(963)984506010",
    storageUrl: `https://admin.cuerox.com/`,
    multipleMediaFileUpload: "admin/file-upload",
    multipleMediaImageUpload: `https://admin.cuerox.com/`,
};